//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 29.02.2016.
 */

(function () {

    'use strict';

    angular.module('container.core')
        .config(localization)
        .run(localizationRefresh)
        .factory('Localization', function ($rootScope, $resource, $translate, CONTAINER_API_URL, userSettingsService, Event) {

            var service = {
                languages: [

                    {
                        "languageTag":"en",
                        "country":"",
                        "language":"en",
                        "displayName":"English"
                    }
                ],
                timezones: []
            };

            service.loadSupportedLanguages = function () {

                service.loadUserLanguage();
                $rootScope.$on(Event.USER_LOGGED_IN, service.loadUserLanguage);
            };

            service.loadUserLanguage = () => {

                userSettingsService.loadUserSetting('container', 'language')
                    .then(language => {
                        service.changeLanguage(language, true);
                    });
            };

            service.changeLanguage = function (language, loadOnly) {

                if (language == null) return;

                console.log('Switch language to ' + language.language);

                if (!loadOnly) userSettingsService.saveUserSetting('container', 'language', language);

                let languageChangePromise = $translate.use(language.language).then(function (data) {
                    $rootScope.$emit('language-changed');
                });

                $rootScope.$emit('handleBusyPromise', languageChangePromise);

            };

            service.changeTimezone = function(timezone, loadOnly) {
                if (timezone == null) return;

                console.log(`Switch timezone to ${timezone}`);

                if (!loadOnly) userSettingsService.saveUserSetting('container', 'timezone', timezone);

                //TODO: Change actual timezone settings when there are any
            }

            return service;
        });


    function localization($translateProvider, $translatePartialLoaderProvider, CONTAINER_API_URL) {

         $translateProvider.useSanitizeValueStrategy('sce');
        $translatePartialLoaderProvider.addPart('container');

        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/files/i18n/{lang}.json'
            // urlTemplate: CONTAINER_API_URL + 'webapi/localizations/{lang}/{part}'
        });

        $translateProvider.fallbackLanguage('en');
        $translateProvider.preferredLanguage('en');
        $translateProvider.use('en'); 

        
    }

    function localizationRefresh($rootScope, $translate) {
        $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
          $translate.refresh();
        });
      }
})();